import { createFileRoute, redirect } from "@tanstack/react-router";

/** The page's address as it was first shared — sends it to the right one. */
export const Route = createFileRoute("/custom-app/migate-to-quote")({
  beforeLoad: () => {
    throw redirect({ to: "/custom-app/migrate-to-quote", replace: true });
  },
});
